import { Component } from '@angular/core';


@Component({
    templateUrl: './blank.component.html',
    styleUrls: ['./blank.component.scss'],
    standalone: false
})
export class BlankComponent {

}
